// 首頁頂部透明；離開頂部 → 變白底；非首頁一律白底
document.addEventListener("DOMContentLoaded", () => {
  const headerSection =
    document.querySelector(".section-header") ||
    document.querySelector(".shopify-section-header") ||
    document.querySelector('[class*="section-header"]');
  if (!headerSection) return;

  headerSection.classList.add("header-sticky");

  const setHeaderHeight = () => {
    const h = headerSection.offsetHeight || 72;
    document.documentElement.style.setProperty("--header-h", `${h}px`);
  };
  setHeaderHeight();
  window.addEventListener("resize", setHeaderHeight);

  // 🔍 判斷是否為首頁
  const isHome =
    document.body.classList.contains("template-index") || // Shopify 預設首頁模板 class
    window.location.pathname === "/" ||
    window.location.pathname === "/index";

  const TRANSITION_POINT = 100;

  if (isHome) {
    // ✅ 首頁才啟用滾動透明/白底切換
    const applyState = () => {
      const y = window.pageYOffset;
      if (y > TRANSITION_POINT) {
        headerSection.classList.add("is-solid");
        document.body.classList.add("header-open");
      } else {
        headerSection.classList.remove("is-solid");
        document.body.classList.remove("header-open");
      }
    };

    applyState();

    let ticking = false;
    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            applyState();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );
  } else {
    // 🚫 其他頁面：一律固定白底
    headerSection.classList.add("is-solid");
    document.body.classList.add("header-open");
  }

  // Shopify 編輯器監聽（不動）
  document.addEventListener("shopify:section:load", setHeaderHeight);
  document.addEventListener("shopify:section:reorder", setHeaderHeight);
});

// --- 保險：偵測手機漢堡是否開啟，切換 body.nav-open 讓 CSS 生效 ---
(() => {
  const openedSelector = `
    .menu-drawer[open],
    header-drawer[open],
    details[open].menu-drawer-container,
    details[open][id*="menu"]
  `;

  const syncNavOpen = () => {
    const isOpen = !!document.querySelector(openedSelector);
    document.body.classList.toggle('nav-open', isOpen);
  };

  // 初始同步
  syncNavOpen();

  // 監看 open / aria-* 屬性變化（抽屜開關幾乎都會動到這些）
  const mo = new MutationObserver(syncNavOpen);
  mo.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'aria-hidden', 'aria-expanded', 'class']
  });

  // 有些版本用 toggle/click：保險再掛一次
  document.addEventListener('toggle', () => setTimeout(syncNavOpen, 0), true);
  document.addEventListener('click',  () => setTimeout(syncNavOpen, 0), true);
})();
